export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Explore luxury shopping, fine dining, and fun events at Highland Park Village in Dallas."},{"name":"author","content":"Highland Park Village"},{"hid":"image","name":"image","content":"/Images/SEO/Highland_Park_Village.jpg"},{"name":"application-name","content":"Highland Park Village"},{"hid":"twitter","name":"twitter:card","content":"summary"},{"hid":"twitter:site","name":"twitter:site","content":""},{"hid":"og:title","property":"og:title","name":"og:title","content":"Luxury Shopping and Fine Dining at Highland Park Village"},{"hid":"og:description","property":"og:description","name":"og:description","content":"Explore luxury shopping, fine dining, and fun events at Highland Park Village in Dallas."},{"hid":"og:type","property":"og:type","name":"og:type","content":"website"},{"hid":"og:url","property":"og:url","name":"og:url","content":"https://hpvillage.com/"},{"hid":"og:locale","property":"og:locale","name":"og:locale","content":"en_US"},{"hid":"og:image","property":"og:image","name":"og:image","content":"/Images/SEO/Highland_Park_Village.jpg"},{"hid":"og:image:secure","property":"og:image:secure","content":"/Images/SEO/Highland_Park_Village.jpg"},{"hid":"og:image:secure_url","property":"og:image:secure_url","content":"/Images/SEO/Highland_Park_Village.jpg"},{"hid":"og:image:height","property":"og:image:height","content":"400"},{"hid":"og:image:width","property":"og:image:width","content":"400"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"apple-mobile-web-app-title","content":"Highland Park Village"},{"name":"theme-color","content":"#000000"},{"name":"facebook-domain-verification","content":"8ud06bw6sl1zzgxtz5pjyhyjgd60q0"},{"name":"msvalidate.01","content":"313A2E5014F6BA1ED165FAA6B19DDD0C"},{"name":"google-site-verification","content":"Lb2NtFmwLd5MtEsbme9UVPDV1FUE7zy80a_NEMpQi8w"},{"name":"google-site-verification","content":"l4XwENBsnwNa8LJNHvMY9ZfhhoCJ-Ooayxorn5bZhJk"}],"link":[{"rel":"icon","href":"/Images/logos/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/Images/logos/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/Images/logos/favicons/favicon-16x16.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"180x180","href":"/Images/logos/favicons/apple-touch-icon.png"},{"rel":"stylesheet","href":"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"},{"rel":"manifest","href":"/Images/logos/favicons/site.webmanifest"},{"rel":"mask-icon","href":"/favicon/safari-pinned-tab.svg","color":"#5bbad5"},{"rel":"stylesheet","href":"https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css","integrity":"sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N","crossorigin":"anonymous"}],"style":[],"script":[{"src":"/javascripts/page_insight_config.js","type":"text/javascript"},{"src":"https://cdn.monsido.com/page-assist/v2/mon-page-assist-loader.js","type":"text/javascript","async":true},{"src":"https://monsido-consent.com/v1/mcm.js","type":"text/javascript"},{"src":"https://app-script.monsido.com/v2/monsido-script.js","type":"text/javascript","async":true},{"src":"/javascripts/microsoftClarity.js","type":"text/javascript","defer":true},{"src":"https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.slim.min.js","integrity":"sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj","crossorigin":"anonymous","tagPosition":"bodyClose"},{"src":"https://www.google.com/recaptcha/api.js","async":true,"defer":true},{"src":"https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.bundle.min.js","integrity":"sha384-Fy6S3B9q64WdZWQUiU+q4/2Lc9npb8tCaSX9FK7E8HnRr0Jz8D6OP9dO5Vg3Q9ct","crossorigin":"anonymous","tagPosition":"bodyClose"},{"src":"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js","async":true}],"noscript":[],"htmlAttrs":{"lang":"en"},"title":"Luxury Shopping and Fine Dining at Highland Park Village"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true